import React, { Fragment } from "react";
import ChartTable from "../../../../../d3Components/linechart/chartTable";
import Legend from "../../../../../d3Components/legend";
import NewLine from "../../../../../d3Components/NewLineChart/NewLine/newLine";
import ContainerDimensions from "react-container-dimensions";
// import DropDown from "../../../common/dropDown/dropDown";
import Scatter from "../../../../../d3Components/scatterPlot/Scatter";

const ChartHolder = (props) => {
  const {
    getBacktest,
    typeName,
    benchmark_name,
    selected,
    onclickHandler,
    display_orig_portfolio,
    PortfolioVami,
    BenchmarkVami,
    getBacktest_orig,
    newBenchmarkName,
    model_name,
  } = props;

  let BenchmarkData = BenchmarkVami.map((d) => {
    return [new Date(d.dt), d.vami * 1];
  });
  let PortfolioData = PortfolioVami.map((d) => {
    return [new Date(d.dt), d.vami * 1];
  });

  let initialDate = new Date(props.initialDate);
  let endDate = new Date(props.endDate);

  let BenchmarkFilter = [];
  for (let i = 0; i < BenchmarkData.length; i++) {
    if (BenchmarkData[i][0] >= initialDate && BenchmarkData[i][0] <= endDate)
      BenchmarkFilter.push(BenchmarkData[i]);
  }

  let PortfolioFilter = [];
  for (let i = 0; i < PortfolioData.length; i++) {
    if (PortfolioData[i][0] >= initialDate && PortfolioData[i][0] <= endDate)
      PortfolioFilter.push(PortfolioData[i]);
  }
  BenchmarkFilter.sort((a, b) => new Date(a[0]) - new Date(b[0]));
  PortfolioFilter.sort((a, b) => new Date(a[0]) - new Date(b[0]));

  let Line_chart_data = [
    {
      data: PortfolioFilter,
      label: "Portfolio",
    },
    {
      data: BenchmarkFilter,
      label:
        display_orig_portfolio && benchmark_name
          ? "Benchmark *"
          : benchmark_name,
    },
  ];

  //  *********** orig line data **********
  if (Object.keys(getBacktest_orig).length) {
    let data;

    data = getBacktest_orig.getPortfolioVami;
    // if (
    //   props.orig_lineChart_data
    //   &&
    //   props.orig_lineChart_data.includes("portfolio")
    // ) {
    //   data = props.getBacktest_orig.getPortfolioVami;
    // } else {
    //   data = props.getBacktest_orig.getBenchmarkVami;
    // }
    var Orig_Benchmark = data.map((d) => {
      return [new Date(d.dt), d.vami * 1];
    });
    var BenchmarkFilter_orig = [];
    for (let i = 0; i < Orig_Benchmark.length; i++) {
      if (
        Orig_Benchmark[i][0] >= initialDate &&
        Orig_Benchmark[i][0] <= endDate
      )
        BenchmarkFilter_orig.push(Orig_Benchmark[i]);
    }
    BenchmarkFilter_orig.sort((a, b) => new Date(a[0]) - new Date(b[0]));

    Line_chart_data.push({
      data: BenchmarkFilter_orig,
      label: display_orig_portfolio
        ? "Original Portfolio"
        : newBenchmarkName
        ? newBenchmarkName
        : data[0].benchmark_name,
    });
  }

  // const BenchmarkName = () => {
  //   if (props.display_orig_portfolio) {
  //     return <small>* {props.benchmark_name}</small>;
  //   } else if (props.newBenchmarkName) {
  //     return <small>* {props.newBenchmarkName}</small>;
  //   } else {
  //     return <small>* {props.benchmark_name}</small>;
  //   }
  // };
  // ***************************************

  // hamburger options
  // var options = [
  //   {
  //     name: "lineChart",
  //     text: "Line Chart",
  //     icon: "fa-line-chart fs_icon_option"
  //   },
  //   { name: "scatterChart", text: "Scatter Chart", icon: "fa-scatter-chart-o" }
  // ];
  // var style = { left: "-150px", right: "20px" };

  return (
    <Fragment>
      {/* {BenchmarkFilter.length ? (
        <div className="scrollX">
          <ChartTable data={getBacktest.getPortfolioMetrics[0]} />
        </div>
      ) : null} */}
      {BenchmarkFilter.length ? (
        <div style={{ paddingTop: "15px" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Legend
              height={30}
              width={500}
              legend1={
                newBenchmarkName
                  ? `IQCIO portfolio ${model_name ? "+" : ""}`
                  : null
              }
              legend2={
                display_orig_portfolio
                  ? "Benchmark *"
                  : benchmark_name
                  ? "Benchmark"
                  : typeName
              }
              legend3={
                display_orig_portfolio
                  ? "Original portfolio"
                  : newBenchmarkName
                  ? newBenchmarkName
                  : null
              }
              legend3Start={false}
            />
            {/* <DropDown
              data={options}
              onclickHandler={onclickHandler}
              style={style}
            ></DropDown> */}
          </div>
          <Fragment>
            {selected === "lineChart" && display_orig_portfolio === false ? (
              <ContainerDimensions>
                {({ width }) => (
                  <Fragment>
                    {width > 0 ? (
                      <NewLine
                        chartId={"line_chart_02"}
                        data={Line_chart_data}
                        height={300}
                        width={width}
                      />
                    ) : null}
                  </Fragment>
                )}
              </ContainerDimensions>
            ) : null}
            <Fragment>
              {selected === "lineChart" &&
              display_orig_portfolio === true &&
              Line_chart_data.length > 1 ? (
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 ? (
                        <NewLine
                          chartId={"line_chart_02"}
                          data={Line_chart_data}
                          height={300}
                          width={width}
                        />
                      ) : null}
                    </Fragment>
                  )}
                </ContainerDimensions>
              ) : null}
            </Fragment>

            {/* {benchmark_name && selected === "lineChart" ? (
              <div>{BenchmarkName()}</div>
            ) : null} */}
          </Fragment>
          <Fragment>
            {selected === "scatterChart" ? (
              <ContainerDimensions>
                {({ width }) => (
                  <Fragment>
                    {width > 0 ? (
                      <Scatter
                        id="scatter_01"
                        width={width}
                        height={350}
                        MainData={Line_chart_data}
                      />
                    ) : null}
                  </Fragment>
                )}
              </ContainerDimensions>
            ) : null}
          </Fragment>
        </div>
      ) : null}
    </Fragment>
  );
};

export default ChartHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/portfolioGrowth/section1/chartHolder.jsx